import cx from 'classnames'
import Downshift from 'downshift'
import throttle from 'lodash/throttle'
import * as React from 'react'

import { times } from '../../icons'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import request from '../../utils/request'
import Button from '../_legacy/Button'
import Icon from '../Icon/Icon'
import styles from './searchBar-style.css'

type Props = {
  searchBtn?: SearchBarViewModel
  id: string
  onSearchToggle?: (...args: any[]) => any

  /** @internal */
  onSubmit?: (...args: any[]) => any

  /** @internal */
  className?: string

  /** @internal */
  loading?: boolean
  isSearchOpen?: boolean
  searchPhrase?: string
}
type State = {
  results: Record<string, any>[]
  value: string
  suggestionsOpen: boolean
}

class SearchBar extends React.Component<Props, State> {
  static displayName = 'SearchBar'
  static defaultProps = {
    id: 'search',
  }
  state = {
    results: [],
    value: this.props.searchPhrase || '',
    suggestionsOpen: false,
  }
  //TODO: any
  input: React.RefObject<any> = React.createRef()
  throttledFetch = throttle((value: any) => this.fetchResults(value), 250)
  //TODO: any
  inputOnChange = (e: any) => {
    const { value } = e.target
    this.setState({
      value,
      suggestionsOpen: true,
    })
    if (value.length > 1) this.throttledFetch(value)
  }
  handleDownshiftChange = (value: Record<string, any>) => {
    this.setState({
      value: value.heading,
      suggestionsOpen: false,
    })
    this.triggerSearch(value.heading)
  }
  //TODO: Is this correct?
  handleSubmit: (...args: any[]) => any = (e: Event) => {
    e.preventDefault()
    const { value } = this.state
    this.triggerSearch(value)
  }
  triggerSearch = (value: string) => {
    const { onSubmit } = this.props as Props
    this.setState({
      suggestionsOpen: false,
    })

    if (value && onSubmit) {
      onSubmit(value)
    }
  }
  fetchResults = (query: string) => {
    const { searchBtn } = this.props
    if (!searchBtn) return null
    const queryUrl = `${searchBtn.apiString}${query}`
    request(queryUrl)
      .then((res) => {
        if (query === this.state.value) {
          this.setState({
            results: res.body,
          })
        }
      })
      .catch((err) => console.error(err.error))
  }

  componentDidUpdate(prevProps: Record<string, any>) {
    if (prevProps.isSearchOpen !== this.props.isSearchOpen && this.props.isSearchOpen === true) {
      this.input?.current?.focus()
    }

    if (prevProps.isSearchOpen !== this.props.isSearchOpen && this.props.isSearchOpen === false) {
      this.setState({
        value: '',
      })
    }
  }

  render() {
    const { id, searchBtn, onSearchToggle, className, loading } = this.props
    const { results, suggestionsOpen } = this.state
    if (!searchBtn) return null

    return (
      <div className={cx(styles.searchBar, className)}>
        <form id={id} onSubmit={this.handleSubmit}>
          <Downshift
            id={"downshift-1-label"}
            isOpen={suggestionsOpen}
            onOuterClick={() =>
              this.setState({
                suggestionsOpen: false,
              })
            }
            onChange={this.handleDownshiftChange}
            itemToString={(item) => (item ? item.heading : '')}
            inputValue={this.state.value || ''}
          >
            {({ getInputProps, getItemProps, highlightedIndex, isOpen }) => (
              <div className={styles.inputHolder}>
                <div className={styles.inputHolderInner}>
                  <div className={styles.closeMobile} onClick={onSearchToggle}>
                    <Icon iconSrc={times} width="15px" height="15px" />
                  </div>
                  <input
                    {...getInputProps({
                      placeholder: searchBtn.placeholder,
                      onChange: this.inputOnChange,
                    })}
                    ref={this.input}
                  />
                  <Button small type="submit">
                    {searchBtn.triggerText}
                  </Button>
                </div>
                {isOpen && results && results.length > 0 && !loading && (
                  <div className={styles.results}>
                    {results.map((item: Record<string, any>, index: number) => (
                      <div
                        {...getItemProps({
                          key: index,
                          index,
                          item,
                        })}
                        style={{
                          color: highlightedIndex === index ? '#00b668' : '#004232',
                        }}
                        className={styles.result}
                      >
                        {item.heading}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </Downshift>
        </form>
      </div>
    )
  }
}

export default SearchBar
